// pages/StockAnalysis.jsx
import { useState } from "react";
import ModalViewAb from '_utils/ModalViewAb'
import CompanyAboutSection from 'components/company/companyAboutSection';
import FundamentalBlock from "./fundamentalblock";
import { BankingBlock, CorporateBlock, InsuranceBlock } from "./SectorBlock";

export default function ({ data , companyinfo }) {
  const { company, sector, type } = data;
   const [isExpanded, setIsExpanded] = useState(false);
    const [open, setOpen] = useState(false);
  
    const openPopup = () => {
      setOpen(true);
    };
  //console.log('company type=====:', type)


  return (
    <>
        {/*<h2 className="text-2xl font-semibold py-1">{company} Fundamental Snapshot</h2>
       <FundamentalBlock company={company} sector={sector} companyinfo={companyinfo} ratios={data?.ratios} />*/}
        <button
        onClick={openPopup}
        className="text-accent font-medium mt-1 hover:underline"
      >
        About Company
      </button>
         <ModalViewAb open={open} onClose={() => setOpen(false)}>
              <div className="flex flex-col justify-center w-full">
                    <CompanyAboutSection companyinfo={companyinfo} onClose={() => setOpen(false)} />
                </div>  
              {/* <LoginwithEmail goTo={window.location.href} />
              <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
              */}
            </ModalViewAb>
    </>
  );
}
